import React, { useEffect, useState } from 'react'

import HoverIcon from '../../Icons/HoverIcon'
import { faGripLines } from '@fortawesome/pro-solid-svg-icons'
import { getDisplacement } from '../utils'

const VerticalDragLine = ({ base, displacement, offset, min, onChange }) => {
  const [initialYIndex, setInitialYIndex] = useState(0)
  const [initialOffset, setInitialOffset] = useState(offset)
  const [yIndex, setYIndex] = useState({ current: 0, previous: 0 })

  useEffect(() => {
    if (initialYIndex === 0) {
      setInitialOffset(offset)
    }
  }, [offset, initialYIndex])

  const currentTop = (displacement * (initialOffset) - (displacement / 2)) + (yIndex.current - initialYIndex - (initialYIndex === 0 ? 0 : 75))
  const height = displacement + (initialYIndex === 0 ? 0 : 150)

  const handleOnMouseDown = e => {
    e.preventDefault()
    e.stopPropagation()

    setInitialYIndex(e.clientY)
    setYIndex({ current: e.clientY, previous: e.clientY })
  }

  const handleOnMouseUp = e => {
    setYIndex({ current: 0, previous: 0 })
    setInitialYIndex(0)
    setInitialOffset(offset)
  }

  const logMouseMovement = e => {
    e.stopPropagation()
    e.preventDefault()

    if (e.clientY && initialYIndex) {
      setYIndex({ current: e.clientY, previous: yIndex.current })

      const displacementIndex = getDisplacement(initialYIndex, e.clientY, displacement)

      if (initialOffset + displacementIndex !== offset) {
        onChange(initialOffset + displacementIndex >= min ? displacementIndex + initialOffset : min)
      }
    }
  }

  return (
    <div
      className='w-100 cu-ns-resize'
      style={{ position: 'absolute', left: 0, top: currentTop, height, zIndex: 100 }}
      onMouseDown={handleOnMouseDown}
      onMouseUp={handleOnMouseUp}
      onMouseMove={logMouseMovement}
      onMouseLeave={handleOnMouseUp}
    >
      <HoverIcon icon={faGripLines} />
    </div>
  )
}

export default VerticalDragLine
